import { Component, HostListener, OnInit } from '@angular/core';
import { PushNotificationService } from './core/services/push-notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'frontend';

  constructor(
    private pushService: PushNotificationService
  ) {
    // Session restoration is now handled by AuthGuard on each route activation.
    // This avoids a double-call to /auth/me and eliminates the race condition.
    // Clean up legacy token from localStorage (one-time migration)
    localStorage.removeItem('token');
  }

  async ngOnInit() {
    this.setViewportHeight();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', () => this.setViewportHeight());
    }

    // Initialize Push Notifications
    await this.pushService.init();
    this.pushService.listenForMessages();
  }

  @HostListener('window:resize')
  onResize() {
    this.setViewportHeight();
  }

  private setViewportHeight() {
    const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.documentElement.style.setProperty('--app-height', `${vh}px`);
  }
}
